import { useEffect} from "react";
import { useNavigate } from "react-router-dom";
import { fullPageLoader, updateAlertMessage } from "../../../api-integration/commonSlice";
import { useDispatch } from "react-redux";
import { useExternalIntegrationMutation } from "../../../api-integration/public/public";

const KioskExternalGateway = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const [externalGatewayAPI, { data: externalGatewayData, isSuccess: isExternalGatewaySuccess, isError: isExternalGatewayError }] 
    = useExternalIntegrationMutation();

    useEffect(() => {
        const queryString = window.location.search;
        const params = new URLSearchParams(queryString);
        const queryParams: any = {};
        params.forEach((value, key) => {
        queryParams[key] = value;
        });
        dispatch(fullPageLoader(true));
        externalGatewayAPI(queryParams);
    }, []);

    // Function to extract the "returnTo" value from the "state" URL parameter
    const getReturnToFromState = (): string | null => {
        // Get the full query string from the current URL (e.g., "?code=...&state=...")
        const queryString = window.location.search;

        // Parse the query string into key-value pairs
        const params = new URLSearchParams(queryString);

        // Get the value of the "state" parameter from the URL
        const stateParam = params.get("state");

        if (stateParam) {
            // Decode the URL-encoded state string
            const decodedState = decodeURIComponent(stateParam);

            // Parse the decoded state string into a JSON object
            const parsedState = JSON.parse(decodedState);    

            // Return the "returnTo" value if it exists, otherwise return null
            return parsedState?.returnTo || null;
        }
        // If "state" is not present, return null
        return null;
    };

    const performAsyncOperation = async () => {
        try {
            // This is initialized outside as it might be used in multiple conditions
            let isConsentProvided = false;
            let isPhoneVerified = false;
            if (externalGatewayData?.user) {
                const userDetails = externalGatewayData?.user;
                const userKioskDetails = externalGatewayData?.userKioskDetails;
                localStorage.setItem('refreshToken', userDetails?.refreshToken);
                isConsentProvided = userKioskDetails?.isConsentProvided || false;
                isPhoneVerified = userKioskDetails?.isPhoneVerified || false;
                const user = {
                    accId: userDetails?.accId,
                    accountType: userDetails?.accountType,
                    userEmail: userDetails?.userEmail,
                    isNewUser: userDetails?.isNewUser,
                    userBusinessEmail: userDetails?.userBusinessEmail,
                    userId: userDetails?.userId,
                    firstName: userDetails?.firstName,
                    lastName: userDetails?.lastName,
                    picPath: userDetails?.picPath,
                    totalCCPoints: userDetails?.totalCCPoints,
                    usrCreatedDate: userDetails?.usrCreatedDate,
                    blcFlag: userDetails?.blcFlag,
                    orgId: userDetails?.orgId,
                    isProfileComplete: userDetails?.isProfileComplete,
                    promptExeAlert: userDetails?.promptExeAlert,
                    userCompanyData: userDetails?.companyData,
                    userRoles: userDetails?.userRoles || [],
                    isConsentProvided: isConsentProvided,
                    isPhoneVerified: isPhoneVerified
                }
                localStorage.setItem('user', JSON.stringify(user));
                localStorage.setItem('isConsentProvided', JSON.stringify(isConsentProvided) || "false");
                localStorage.setItem('isPhoneVerified', JSON.stringify(isPhoneVerified) || "false");
                localStorage.setItem('isLoggedIn', 'true');
                // dispatch(updateUser(user));
            }
            if(externalGatewayData?.otp) {
                const otpInfo = externalGatewayData?.otp?.data;
                localStorage.setItem('otpInfo', JSON.stringify(otpInfo));
            }

            dispatch(fullPageLoader(false));
            // PRIORITY 1 -> CONSENT
            if (!isConsentProvided) {
                navigate('/consent');
                return;
            }
            // PRIORITY 2 -> PHONE VERIFICATION
            if (!isPhoneVerified) {
                navigate('/verify');
                return;
            }
            // PRIORITY 3 -> RETURN URL
            const navigateToPage = getReturnToFromState();
            if (navigateToPage) {
                window.location.href = navigateToPage;
                return;
            }
            // DEFAULT
            navigate('/home');
            return;
        } catch (error) {
            console.error('[ExternalGateway] performAsyncOperation error', error);
        } finally {
            dispatch(fullPageLoader(false)); 
        }
    };

    useEffect(() => {
        if(isExternalGatewaySuccess) {
            dispatch(fullPageLoader(false));
            if(externalGatewayData?.success === true) {
                performAsyncOperation();
            }
            else {
                dispatch(updateAlertMessage({ status: 'error', message: externalGatewayData?.message }));
                navigate('/login', { state: { errorMessage: externalGatewayData?.message } });
            }
        }  
        else if (isExternalGatewayError) {
            dispatch(fullPageLoader(false));
            navigate('/login', { state: { errorMessage: "Unable to login with social account, please try again later" } });
        }
    }, [isExternalGatewaySuccess, isExternalGatewayError]);

    return <></>
}

export default KioskExternalGateway;